import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import axios from "react-axios";
import { Link, useHistory } from "react-router-dom";

import { useUser } from "~/Context/userContext";
import Alert from "react-bootstrap/Alert";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AvatarUpload from "~/Components/Elements/Global/AvatarUpload";
import UserProfileContainer from "./UserProfileContainer";
import { LOCAL_STORE_JWT } from "~/utils/main";
import UserSocialEditForm from "~/Components/Elements/Forms/User/UserSocialEditForm";
import { postAvatarUpload } from "~/api/getUser";

// This might not be used anymore
const UserProfileEditPage = ({ match }) => {
  const jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;
  let history = useHistory();
  const { state: userState } = useUser();
  const [userDir, setUserDir] = useState(match.params.userDir);

  const [avatarUploading, setAvatarUploading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [failure, setFailure] = useState(false);
  const [avatarUpload, setAvatarUpload] = useState(null);

  const isSelf = userState.loggedin && userState.user && userState.user.dir === match.params.userDir;

  const backButton = () => {
    // history.push(`/user/${dir}`);
    history.goBack();
  };

  const onFailure = () => {
    setFailure(true);
  };
  const onFailureSocial = (e) => {
    console.log("onFailureSocial:", e);
    //setFailure(true);
  };
  const onSaveSocial = () => {
    setSaved(true);
    window.scrollTo(0, 0);
    history.push(`/user/${match.params.userDir}`);
  };
  const saveAvatar = () => {
    if (!avatarUpload) return false;

    setAvatarUploading(true);
    const formData = new FormData();
    formData.append("jwt", jwt);
    formData.append("avatar", avatarUpload);

    postAvatarUpload(axios, formData)
      .then(() => {
        setAvatarUploading(false);
        setSaved(true);
        window.scrollTo(0, 0);
        history.push(`/user/${match.params.userDir}`);
      })
      .catch((e) => setAvatarUploading(false));
  };

  const avatarHandler = (file) => {
    setAvatarUpload(file[0]);
  };

  if (!isSelf) {
    return <Redirect to={`/`} />;
  }
  return (
    <div className="ProfileEditPageWrapper">
      <div className="page-header">
        <h2>Edit Your Profile</h2>
        <br />
        {saved && (
          <Alert variant="success" onClose={() => setSaved(false)} dismissible>
            Thanks. <Link to={`/user/${match.params.userDir}`}>Your profile</Link> was saved.
          </Alert>
        )}
        {failure && !saved && <Alert variant="danger">There was an error while saving. Check the input and try again.</Alert>}

        <UserProfileContainer
          userDir={userDir}
          render={({ profile, social, loading }) => {
            if (loading) {
              return (
                <SkeletonTheme color="#fff" highlightColor="#f3f3f3">
                  <Skeleton count={4} />
                </SkeletonTheme>
              );
            }
            return (
              <Row className="with-col-list">
                <Col sm={5} xs={12} className="text-left">
                  <h3 className="page-header section-heading-lite">Avatar</h3>

                  {profile.avatar && (
                    <div>
                      <h4>Current Avatar</h4>
                      <img src={profile.avatar} style={{ maxWidth: "100px", marginBottom: "22px" }} />
                    </div>
                  )}

                  <p>Upload your most recently purchased album cover as your avatar</p>
                  <AvatarUpload onChange={avatarHandler} />

                  <div>{avatarUploading && <Spinner animation="border" variant="dark" />}</div>

                  <Button disabled={avatarUploading} onClick={saveAvatar} variant="success" type="submit">
                    Upload &amp; Save Avatar
                  </Button>
                </Col>
                <Col sm={12} md={{ span: 6, offset: 1 }}>
                  <h3 className="page-header section-heading-lite">Social Networks</h3>

                  {/* List of Social Networks */}
                  <UserSocialEditForm profile={profile} onFailure={onFailureSocial} onComplete={onSaveSocial} />
                </Col>
              </Row>
            );
          }}
        />
      </div>
      <div style={{ marginTop: "40px" }}>
        <Button onClick={(e) => backButton(e)} variant="cancel" type="cancel">
          &laquo; Back to Profile
        </Button>
      </div>
    </div>
  );
};

export default UserProfileEditPage;
